import React, { Component } from 'react';
import { Spin, message, Button, Input, Select } from 'antd';
import TableC from '../../basicElement/TableC';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import SelectProvince from '../../common/SelectProvince';
import AddressInfo from './components/AddressInfo';
import InstitutionalFilingInfo from './components/InstitutionalFilingInfo';
import AssociatedHospital from './components/AssociatedHospital';
import moment from 'moment';

const Option = Select.Option;

class Filter extends Component {
    state = {
        searchParams: {},
    }

    search = () => {
        const {
            searchParams,
            searchParams: {
                areaParams,
            },
        } = this.state;
        this.props.search({ ...searchParams, ...areaParams, areaParams: '', hasCheckedArea: '' });
    }

    export = () => {
        const { searchParams } = this.state;
        this.props.exportData(searchParams);
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    render() {
        const {  searchParams, hasCheckedArea = [] } = this.state;
        const { curRole } = sessionStorage;
        const { areaNameList } = this.props;
        const areaNameOption = (areaNameList || []).map(el => <Option key={el} value={el}>{el}</Option>);
        return (
                <div className="search-bar" style={{ marginBottom: 10 }}>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">备案号</label>
                        <Input
                            style={{width: 140}}
                            placeholder="请输入"
                            value={searchParams.recordNo}
                            onChange={e => this.handleChange(e.target.value, 'recordNo')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">机构名称</label>
                        <Input
                            style={{width: 140}}
                            placeholder="请输入"
                            value={searchParams.compName}
                            onChange={e => this.handleChange(e.target.value, 'compName')}
                        />
                    </div>
                    <div className="search-item" style={{ height: 30 }}>
                        <label className="ui-label">省份/地区</label>
                            <Select
                                style={{width: 140}}
                                placeholder="请选择省份"
                                allowClear
                                value={searchParams.areaName}
                                onChange={value => this.handleChange(value, 'areaName')}
                            >
                                {areaNameOption}
                            </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">主要研究者</label>
                        <Input
                            style={{width: 140}}
                            placeholder="请输入"
                            value={searchParams.profPersonName}
                            onChange={e => this.handleChange(e.target.value, 'profPersonName')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">专业</label>
                        <Input
                            style={{width: 140}}
                            placeholder="请输入"
                            value={searchParams.profAllName}
                            onChange={e => this.handleChange(e.target.value, 'profAllName')}
                        />
                    </div>
                    <div className="search-item">
                        <Button className="btn" type="primary" onClick={this.search}>搜索</Button>
                        {curRole !== 'CRC' && <Button className="btn" type="primary" onClick={this.export}>导出</Button>}
                    </div>
                </div>
        );
    }
}


class MedicalDevicesList extends Component {
    state = {
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        },
        areaNameList: [],
    }

    componentDidMount() {
        this.loadData();
        this.queryAreaName();
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryBasicInfo,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                recordType: '02',
            },
            dataType: 'json',
            doneResult: res => {
                const { dataResult = {} } = res;
                const { datas, totalCount } = dataResult;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination
                });
            }
        };
        $.sendRequest(options);
    };

    queryAreaName = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.config.queryAreaName,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { areaNameList } = res;
                this.setState({
                    areaNameList,
                });
            }
        };
        $.sendRequest(options);
    };


    exportData = (params) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.exportBasicInfo,
            data: {
                ...params,
                recordType: '02',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                });
                message.success(res.success);
            }
        };
        $.sendRequest(options);
    }

    search = params => {
        const { pagination } = this.state;
        const searchParams = { ...params };
        this.setState({
            searchParams,
            pagination: {
                ...pagination,
                current: 1,
            },
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const columns = [
            {
                title: '省份/地区',
                dataIndex: 'areaName',
                key: 'areaName',
                width: 100,
            },
            {
                title: '备案号',
                dataIndex: 'recordNo',
                key: 'recordNo',
                width: 100,
            },
            {
                title: '机构名称',
                dataIndex: 'compName',
                key: 'compName',
                width: 100,
            },
            {
                title: '地址',
                dataIndex: 'address',
                key: 'address',
                width: 100,
                render: (text, record) => {
                    const { addressList } = record;
                    return addressList ? <a onClick={() => this.AddressInfoRef.show(record)}>{text}</a> : text
                }
            },
            {
                title: '医院名称',
                dataIndex: 'hospitalName',
                key: 'hospitalName',
                width: 100,
            },
            {
                title: '院区',
                dataIndex: 'courtyardArea',
                key: 'courtyardArea',
                width: 100,
            },
            {
                title: '联系人',
                dataIndex: 'linkMan',
                key: 'linkMan',
                width: 100,
            },
            {
                title: '联系方式',
                dataIndex: 'linkTel',
                key: 'linkTel',
                width: 100,
            },
            {
                title: '备案状态',
                dataIndex: 'recordStatus',
                key: 'recordStatus',
                width: 160,
                render: (text, record) => {
                    const { cancelRecordTime } = record;
                    return text ? text === '8' ? '已备案' : `取消备案（${moment(cancelRecordTime).format('YYYY-MM-DD')}）` : ''
                }
            },
            {
                title: '机构备案信息',
                dataIndex: 'compInfo',
                key: 'compInfo',
                width: 100,
                render: (text, record) => {
                    return <a onClick={() => this.InstitutionalFilingInfoRef.show(record, '01')}>查看详情</a>
                }
            },
            {
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 100,
                render: (text, record) => {
                    const { hospitalFlag } = record;
                    return hospitalFlag ? <a onClick={() => this.AssociatedHospitalRef.show(record)}>关联医院</a> : '-'
                }
            }
        ];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const {
            loading,
            pagination,
            data,
            areaNameList,
        } = this.state;

        return (
                <div>
                    <Filter
                        search={this.search}
                        exportData={this.exportData}
                        areaNameList={areaNameList}
                    />
                    <Spin spinning={loading}>
                        <TableC
                            columns={this.getColumns()}
                            data={data}
                            rowKey="companyId"
                            onChange={this.handleTableChange}
                            pagination={pagination}
                        />
                    </Spin>
                    <AddressInfo ref={el => { this.AddressInfoRef = el }} />
                    <InstitutionalFilingInfo ref={el => { this.InstitutionalFilingInfoRef = el }} />
                    <AssociatedHospital ref={el => { this.AssociatedHospitalRef = el }} loadData={this.loadData}/>
                </div>
        );
    }
}


export default MedicalDevicesList


// WEBPACK FOOTER //
// ./src/components/hospital/filingInfo/MedicalDevicesList.js